import { Controller } from "@hotwired/stimulus";

export default class extends Controller {
  scrollToDiv(event){
    var ele = event.target;
    $('html, body').animate({
      scrollTop: $( event.target.getAttribute('href') ).offset().top - 100
    }, 200);
  }
}